module.exports = __webpack_public_path__ + "static/media/docDarkMode.eaebf632.svg";